import styled, { createGlobalStyle } from 'styled-components';
import { Text } from '@usealloy/component-library';

export const StyledAuthContainerView = styled.div`
  background-color: white;
  color: white;
  height: 100%;

  button {
    text-transform: none;
  }

  > div {
    height: 100%;
  }

  a {
    text-decoration: underline;
    margin: 0;
    text-transform: capitalize;
    text-align: center;
  }
`;

export const StyledAlloyLogoBox = styled.div`
  position: absolute;
  top: 32px;
  left: 32px;
  cursor: pointer;
`;

export const StyledSupportButton = styled.button`
  position: absolute;
  display: flex;
  align-items: center;
  top: 32px;
  right: 32px;
  border: none;
  outline: none;
  background: none;
  font-weight: var(--cl-font-weight-regular);
  font-size: var(--cl-font-size-3);

  > span {
    margin-left: 8px;
  }
`;

export const StyledBackButton = styled.button`
  width: max-content;
  border: none;
  outline: none;
  background: none;

  > span {
    margin-left: 8px;
  }
`;

export const StyledAuthFooter = styled.footer`
  position: fixed;
  bottom: 32px;
  font-weight: var(--cl-font-weight-medium);
  font-size: var(--cl-font-size-1);
  color: var(--cl-text-default);
`;

export const StyledLink = styled(Text)`
  color: var(--cl-text-default);
  margin: 0;
  text-decoration: underline;
  text-transform: capitalize;
  text-align: center;
`;

/**
 * Anchors the Messenger panel next to the Support button (top-right) instead of Intercom's
 * default bottom-anchored spot, reusing the pixel offsets already tuned for Zendesk here
 * (FRONTEND-799). Targets `.intercom-messenger-frame` -- Intercom's stable class, not the
 * hashed Emotion class alongside it, which can change per release; the `#intercom-container`
 * ID prefix guarantees this outranks Intercom's own `!important` rule. `transform-origin` is
 * overridden too, since Intercom's default (`left bottom`) suits a bottom-anchored launcher,
 * not this top-right panel. If the panel reverts to Intercom's default position, re-verify
 * these selectors via devtools -- Intercom likely changed its structure.
 *
 * Known limitation: the panel's first-ever mount each page load still animates in from the
 * bottom; every click after that respects the override. Accepted as cosmetic and
 * self-correcting rather than risk a flash from a pre-warm show()/hide() workaround.
 */
export const SupportWidgetPositionOverride = createGlobalStyle`
  #intercom-container .intercom-messenger-frame {
    position: fixed !important;
    top: 50px !important;
    right: 20px !important;
    bottom: auto !important;
    left: auto !important;
    transform-origin: top right !important;
  }
`;

export default {
  StyledAuthFooter,
};
